<template>
    <div class="text-md mb-2 text-center text-orange-500">
        <slot />
    </div>
</template>
